<script>
    import _ from 'lodash';
    import moment from 'moment';
    import {Link} from 'svelte-routing';
    import {network, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import BottomMenu from '../components/BottomMenu.svelte';

	const user = store('credential', 'getAuth');
    const axis = store('axis', '', false);
    
    const fetchOrderList = async () => {
        let list = await network.getOrderList(+$user.id, +$user.idkontr, +$user.idSklad),
            chat = await network.getChatMessagesCount(_.map(list, 'nomer'), +$user.id);
        
        return list.map((item) => {
            let buf;
            
            if ((buf = chat.find(el => item.nomer === el.order)) !== null && buf && buf.count) {
                item.chat = buf.count;
            } else {
                item.chat = 0;
            }
            
            return item;
        });
    }
    let search = '',
        orders = fetchOrderList();

    const filter = _.debounce(async () => {
        let data = await fetchOrderList();
    
        if (search.trim()) {
            return orders = data.filter((item) => {
                return (
                    item.name.indexOf(search) !== -1 ||
                    item.komment.indexOf(search) !== -1
                )
            });
        }
    
        orders = data;
    }, 1000);
</script>

<TopMenu title="Мои заявки" />

<div class="extraHeader">
    <form class="search-form">
        <div class="form-group searchbox">
            <input type="text" class="form-control" placeholder="Поиск по заявкам..." bind:value={search} on:keyup={filter}>
            <i class="input-icon">
                <ion-icon name="search-outline" role="img" class="md hydrated" aria-label="search outline"></ion-icon>
            </i>
        </div>
    </form>
</div>

<div id="appCapsule" class="extra-header-active">
    {#await orders}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title">Загрузка</h5>
                    <p class="card-text">
                        Пожалуйста подождите, мы загружаем список ваших заявок..
                    </p>
                </div>
            </div>
        </div>
    {:then list}
        <div class="section full">
            <div class="bg-white">
                <ul class="listview link-listview">
                    {#each list as item}
                        <li>
                            <Link to="/order/{item.nomer}" class="row py-3">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="row">
                                                <div class="col-12">
                                                    <h4 class="d-inline">#{item.nomer} {item.tipIzd}</h4>
                                                    <span class="text-muted">{moment(item.data).format('DD.MM.YYYY')}</span>
                                                </div>
                                                <div class="col-12">
                                                    <span>{item.tovarName}</span><br>
                                                    <span>{item.komment}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="row text-end">
                                                <div class="col-12 mb-2">
                                                    <div class="chip chip-media">
                                                        <Link to="/chat/{item.nomer}">
                                                            <i class="chip-icon bg-dark">
                                                                <ion-icon name="chatbox-ellipses-outline" role="img" class="md hydrated"></ion-icon>
                                                            </i>
                                                            <span class="chip-label text-black">{@html item.chat ? item.chat : " "}</span>
                                                        </Link>
                                                    </div>

                                                    {#if item.vid === '16'}
                                                        <div class="chip chip-warning">
                                                            <span class="chip-label">Новые</span>
                                                        </div>
                                                    {/if}
                                                    {#if item.vid === '17'}
                                                        <div class="chip chip-primary">
                                                            <span class="chip-label">Отправлен</span>
                                                        </div>
                                                    {/if}
                                                    {#if item.vid === '18'}
                                                        <div class="chip chip-success">
                                                            <span class="chip-label">Дефектовка</span>
                                                        </div>
                                                    {/if}
                                                    {#if item.vid === '19'}
                                                        <div class="chip chip-danger">
                                                            <span class="chip-label">Согласование</span>
                                                        </div>
                                                    {/if}
                                                    {#if item.vid === '20'}
                                                        <div class="chip chip-info">
                                                            <span class="chip-label">Ожидание запчастей</span>
                                                        </div>
                                                    {/if}
                                                    {#if item.vid === '21'}
                                                        <div class="chip chip-warning">
                                                            <span class="chip-label">В работе</span>
                                                        </div>
                                                    {/if}
                                                    {#if item.vid === '22'}
                                                        <div class="chip chip-success">
                                                            <span class="chip-label">Выполненые</span>
                                                        </div>
                                                    {/if}
                                                    {#if item.vid === '23'}
                                                        <div class="chip chip-primary">
                                                            <span class="chip-label">На складе</span>
                                                        </div>
                                                    {/if}
                                                    {#if item.vid === '24'}
                                                        <div class="chip chip-success">
                                                            <span class="chip-label">Отгруженные</span>
                                                        </div>
                                                    {/if}
                                                </div>
                                                <div class="col-12">
                                                    {#if +item.summa}
                                                        <div class="chip chip-media">
                                                            <i class="chip-icon bg-primary">
                                                                <ion-icon name="cash-outline" role="img" class="md hydrated"></ion-icon>
                                                            </i>
                                                            <span class="chip-label">{(+item.summa).toFixed(0)} ₽</span>
                                                        </div>
                                                    {/if}
                                                    {#if +item.summaOpl}
                                                        <div class="chip chip-media">
                                                            <i class="chip-icon bg-success">
                                                                <ion-icon name="cash-outline" role="img" class="md hydrated"></ion-icon>
                                                            </i>
                                                            <span class="chip-label">{(+item.summaOpl).toFixed(0)} ₽</span>
                                                        </div>
                                                    {/if}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
    {/await}
</div>

<BottomMenu />
